import { specialStyle } from "@/assets/utils/specialStyle";

const chartSizeA = specialStyle(document.body.clientHeight, 12)
const chartSizeB = specialStyle(document.body.clientHeight, 14)
const chartSizeC = specialStyle(document.body.clientHeight, 16)
const chartSizeD = specialStyle(document.body.clientHeight, 18)
const chartSizeE = specialStyle(document.body.clientHeight, 20)
const chartSizeF = specialStyle(document.body.clientHeight, 22)
const chartSizeG = specialStyle(document.body.clientHeight, 24)
const chartSizeH = specialStyle(document.body.clientHeight, 28)
const chartSizeI = specialStyle(document.body.clientHeight, 30)
const chartSizeJ = specialStyle(document.body.clientHeight, 40)
const chartSizeK = specialStyle(document.body.clientHeight, 50)

export {
    chartSizeA, chartSizeB, chartSizeC, chartSizeD, chartSizeE, chartSizeF, chartSizeG, chartSizeH,
    chartSizeI, chartSizeJ, chartSizeK
}